import _ from 'lodash';
//mui
import { Button, Stack, Typography, useTheme } from '@mui/material';
import { DataCard } from 'theme/elements/Cards';
import ActivitiesTable from './ActivitiesTable';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import RequestsTable from './RequestsTable';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';

export default function RecentsGallery() {
	const navigate = useNavigate();
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	return (
		<Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
			<DataCard style={{ width: '100%', [theme.breakpoints.up('sm')]: { width: '50%' } }}>
				<Stack
					direction={'row'}
					alignItems="center"
					margin={{ xs: '0 -16px', sm: 0 }}
					justifyContent={'space-between'}
				>
					<Typography variant="boldBody17">{t('page.dashboard.recent_activity.header.title')}</Typography>
					<Button size="small" variant="text" onClick={() => navigate(`/${pagesEnum.ACTIVITY}`)}>
						<Typography>{t('page.dashboard.recent_activity.show_all_button.text')}</Typography>
					</Button>
				</Stack>
				<ActivitiesTable />
			</DataCard>
			<DataCard style={{ width: '100%', [theme.breakpoints.up('sm')]: { width: '50%' } }}>
				<Stack
					direction={'row'}
					alignItems="center"
					margin={{ xs: '0 -16px', sm: 0 }}
					justifyContent={'space-between'}
				>
					<Typography variant="boldBody17">{t('page.dashboard.pending_requests.header.title')}</Typography>
					<Button size="small" variant="text" onClick={() => navigate(`/${pagesEnum.REQUEST}`)}>
						<Typography>{t('page.dashboard.pending_requests.show_all_button.text')}</Typography>
					</Button>
				</Stack>
				<RequestsTable />
			</DataCard>
		</Stack>
	);
}
